<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="event-result">
    <div class="event-result__header">
      <a :href="url"
         class="event-result__heading">
        {{ name }}
      </a>
    </div>

    <span class="event-result__category">
      {{ formattedCategories }}
    </span>

    <!-- eslint-disable vue/no-v-html-->
    <div class="event-result__description"
         v-html="description">
    </div>
    <!-- eslint-enable vue/no-v-html-->

    <div class="event-result__footer">
      <table class="event-result__details">
        <tr class="event-result__detail">
          <th class="event-result__detail-name">
            <span class="event-result__detail-icon">
              <font-awesome-icon :icon="['far', 'calendar-alt']"></font-awesome-icon>
            </span>

            Start date:
          </th>

          <td class="event-result__detail-value">
            {{ marketingStartDate }}
          </td>
        </tr>

        <tr class="event-result__detail">
          <th class="event-result__detail-name">
            <span class="event-result__detail-icon">
              <font-awesome-icon icon="map-marker-alt"></font-awesome-icon>
            </span>

            Location:
          </th>

          <td class="event-result__detail-value">
            {{ marketingLocation }}
          </td>
        </tr>
      </table>

      <a :href="url"
         rel="nofollow"
         class="btn btn-accent-6 btn-sm event-result__btn">
        Read more
      </a>
    </div>
  </div>
</template>

<script>
import { EcommerceModule } from "spiritweb.packages.ecommerce";

export default {
  name: "EventSearchResult",
  props: {
    url: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    categories: {
      type: Array,
      default: null
    },
    eventId: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: ""
    },
    thumbnailUrl: {
      type: String,
      default: "/Assets/images/no-icon.png"
    },
    thumbnailAltText: {
      type: String,
      default: undefined
    },
    hasWebPage: {
      type: Boolean,
      default: false
    },
    showQuickAdd: {
      type: Boolean,
      default: false
    },
    eventPrice: {
      type: Number,
      default: null
    },
    metaData: {
      type: Object,
      default: null
    },
    marketingLocation: {
      type: String,
      default: null
    },
    marketingStartDate: {
      type: String,
      default: null
    }
  },
  computed: {
    formattedCategories () {
      let result = "";

      if ( this.categories && Array.isArray( this.categories ) ) {
        result = this.categories.join( ", " );
      }

      return result;
    },
    computedDescription () {
      let result = this.description;

      if ( !result ) {
        result = "No description available.";
      }

      return result;
    },
    computedAltText () {
      let result = this.thumbnailAltText;

      if ( !result ) {
        result = `Thumbnail for ${this.name}`;
      }

      return result;
    },
    mobileSrcSet () {
      return `${this.generateUrl( 600 )} 1x, ${this.generateUrl( 1200 )} 2x`;
    },
    src () {
      return this.generateUrl( 160 );
    },
    srcSet () {
      return `${this.generateUrl( 160 )} 1x, ${this.generateUrl( 320 )} 2x`;
    }
  },
  methods: {
    generateUrl ( width ) {
      let result = `/Assets/images/no-icon.png?width=${width}`;

      if ( this.thumbnailUrl ) {
        if ( !this.thumbnailUrl.startsWith( "/" ) ) {
          result = `/remote.axd?${this.thumbnailUrl}?width=${width}`;
        } else {
          result = `${this.thumbnailUrl}?width=${width}`;
        }
      }

      return `${encodeURI( result )}`;
    },
    renderPrice ( input ) {
      return EcommerceModule.renderPrice( input, "gbp", "en-gb" );
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.event-result {
  border: 2px solid fade( @color-accent-6, 70 );
  padding: 15px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  width: 100%;

  &__header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
  }

  &__heading {
    font-size: 1.5rem;
    font-weight: 700;
    color: @color-accent-1;
    line-height: 1;
  }

  &__category {
    color: @color-accent-6;
    font-weight: 600;
  }

  &__description {
    font-size: 13px;
    padding-top: 5px;
    flex-grow: 1;
    margin-bottom: 5px;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media ( max-width: 991px ) {
      flex-direction: column;
      align-items: flex-start;
      padding-top: 5px;
    }
  }

  &__details {
    font-size: 14px;
  }

  &__detail-icon {
    color: @color-accent-6;
    padding-right: 3px;
  }

  &__detail-name {
    font-weight: bold;
    padding-right: 5px;
    min-width: 100px;
  }

  &__btn {
    border-radius: 100px;
    padding: 3px 40px;
    flex-shrink: 0;

    @media ( max-width: 991px ) {
      margin-top: 10px;
    }
  }
}
</style>
